var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCounterIconDestination(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 58,
    viewBox: "0 0 57 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6:12339)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.961 58C19.3318 58 23.6857 55.778 23.6857 53.0369C23.6857 50.2959 19.3318 48.0739 13.961 48.0739C8.59021 48.0739 4.23633 50.2959 4.23633 53.0369C4.23633 55.778 8.59021 58 13.961 58Z",
    fill: "#FF4838"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M45.8306 32.1141C50.0847 32.1141 53.5333 30.3278 53.5333 28.1242C53.5333 25.9206 50.0847 24.1343 45.8306 24.1343C41.5765 24.1343 38.1279 25.9206 38.1279 28.1242C38.1279 30.3278 41.5765 32.1141 45.8306 32.1141Z",
    fill: "#FF4838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2147 27.6667C27.7974 25.3733 27.1881 41.5386 39.4267 38.6298C60.1676 33.7006 61.5225 53.4525 41.974 52.7254C36.8376 52.5343 28.9048 52.6508 25.8037 52.7254",
    stroke: "#FF4838",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1727 53.7181C12.3425 52.7633 2.36015 44.0014 0.308208 33.9475C-1.74374 23.8937 6.85221 17.3221 14.1727 17.3221C20.384 17.3221 28.9799 22.7702 27.8154 33.4981C27.3717 36.8681 25.7634 44.1697 14.1727 53.7181ZM18.4865 28.6108C18.4865 31.0831 16.4604 33.0873 13.9612 33.0873C11.4619 33.0873 9.43582 31.0831 9.43582 28.6108C9.43582 26.1385 11.4619 24.1343 13.9612 24.1343C16.4604 24.1343 18.4865 26.1385 18.4865 28.6108Z",
    fill: "#FF4838"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0949 28.8054C44.6435 28.0496 36.7263 21.1151 35.0989 13.158C33.4715 5.20097 40.289 -5.78936e-06 46.0949 0C51.0212 4.91217e-06 57.8386 4.31191 56.9151 12.8024C56.5631 15.4696 55.2875 21.2484 46.0949 28.8054ZM49.1045 8.66112C49.1045 10.4347 47.682 11.8725 45.9272 11.8725C44.1724 11.8725 42.7498 10.4347 42.7498 8.66112C42.7498 6.8875 44.1724 5.44971 45.9272 5.44971C47.682 5.44971 49.1045 6.8875 49.1045 8.66112Z",
    fill: "#FF4838"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6:12339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 58,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterIconDestination);
export default __webpack_public_path__ + "static/media/counter-icon-destination.27a19a6ff1922a3f6d95bccd17173e83.svg";
export { ForwardRef as ReactComponent };